import { useTranslation } from "react-i18next";

/**
 * Displays pagination info like "Showing 1-15 of 58"
 *
 * @param {Object} props
 * @param {number} props.page - Current page number (1-indexed)
 * @param {number} props.pageSize - Number of items per page
 * @param {number} props.total - Total number of items
 */
export const PaginationInfo = ({ page, pageSize, total }) => {
  const { t } = useTranslation();

  if (!total || total === 0) {
    return (
      <p className="text-sm text-gray-500">
        {t("common.pagination.totalItems", { total: 0 })}
      </p>
    );
  }

  const startItem = (page - 1) * pageSize + 1;
  const endItem = Math.min(page * pageSize, total);

  return (
    <p className="text-sm text-gray-500">
      {t("common.pagination.showingRange", {
        start: startItem,
        end: endItem,
        total: total,
      })}
    </p>
  );
};
